import Background from '../../assets/images/flavours/tivify/svg/background.svg';
import BwLogo from '../../assets/images/flavours/tivify/png/bwLogo.png';
import IFlavour from '../../types/interfaces/flavour';
import Languages from '../../types/enums/languages';
import Logo from '../../assets/images/flavours/tivify/png/big_logo.png';
import MenuSelector from '../../assets/images/png/menuSelector.png';
import TopBarLogo from '../../assets/images/flavours/tivify/png/topBarLogo.png';

const FlavourConfig: IFlavour = {
  apiService: 'tivify',
  appName: 'tivify',
  appTitle: 'Tivify',
  capabilities: {
    cmp: true,
    moreContent: true,
    movieSliders: true,
    showIGuideTv: true,
    uuidLink: false,
    u7d: true,
    watchMore: true,
  },
  carrierId: '5ea94948bf8cbb0072c89fa6',
  defaultUrl: {
    // This will be only used if we got no information from Backend
    account: 'https://tivify.tv/cuenta_usuario',
    activate: 'https://tivify.tv/link',
    register: 'https://tivify.es/es/registro',
    qrUpgrade: 'https://tivify.tv.es/es/registro/?plan=TTRIALPREMIUM',
    omnitrack: 'https://data.tvup.cloud/v2/events/omnitrack',
    freeOmnitrack: 'https://data.tvup.cloud/v2/events/free/omnitrack',
  },
  images: {
    access: Background,
    background: Background,
    logo: Logo,
    bwLogo: BwLogo,
    menuSelector: MenuSelector,
    topBarLogo: TopBarLogo,
  },
  languages: [Languages.ENGLISH, Languages.SPANISH, Languages.CATALAN],
  positions: {
    topBarLogo: {
      y: 0,
    },
    versionRight: true,
  },
  showPrice: true,
  showPlan: true,
  sizes: {
    accessLogo: 195,
    anoymousModalLogo: 360,
    recordModalLogo: 320,
    splashLogo: 578,
    topBarLogo: 38,
  },
  specialLiterals: {
    WELCOME_DESCRIPTION: 'DESCRIPTION_FREE',
  },
  splashBackground: false,
};

export default FlavourConfig;
